<template>
    <form-input
        :label="label"
        :value="value"
        :imask="{
            mask: 'xxxxxxxxxxxxxxxxxxxx',
            prepare: str => {
                return str.toLowerCase()
            },
            definitions: {
                'x': /[a-z0-9]/
            }
        }"
        :disabled="disabled"
        :suffix="`.${domain}`"
        extra-info="What is this?"
        @extra-info-click="showInfo"
        @input="onInput"
    />
</template>

<script>
    import { mapGetters } from 'vuex';
    import { constants } from '../utils/constants';
    const { SUBDOMAIN_MIN_LENGTH, SUBDOMAIN_MAX_LENGTH } = constants;
    const debounce = require('lodash/debounce');

    export default {
        name: 'FormSubdomain',
        props: {
            label: {
                type: String,
                default: 'Site Name',
            },
            value: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            orgId: {
                type: String,
                default: '',
            },
            initialValue: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                isInitial: false,
            };
        },
        computed: {
            ...mapGetters({
                domain: 'base/domain',
            }),
        },
        methods: {
            showInfo() {
                this.$store.dispatch('dialog/set', {
                    type: 'info',
                    header: 'What is this?',
                    body: 'The site name you choose here will be used in all form links you send. Please enter between 6 and 20 alphanumeric (a-z and 0-9) characters that will uniquely identify your organization.',
                    dialogProps: { showX: true }
                });
            },
            onInput(val) {
                this.$emit('input', val);
                if (this.disabled) return;
                this.validate();
            },
            setInitial(isInitial) {
                this.isInitial = isInitial;
            },
            validate() {
                this.$emit('status-change', false);
                this.$store.dispatch('notification/clear');
                this.validateDebounce();
            },
            validateDebounce: debounce(async function() {
                if (this.initialValue && this.initialValue === this.value) {
                    this.$emit('status-change', true);
                    return;
                }
                const len = this.value.length;
                if (len < SUBDOMAIN_MIN_LENGTH || len > SUBDOMAIN_MAX_LENGTH) {
                    if (this.value) {
                        this.$store.dispatch('notification/set', {
                            type: 'info',
                            message: `Site name must be between ${SUBDOMAIN_MIN_LENGTH} and ${SUBDOMAIN_MAX_LENGTH} characters long.`,
                            timeout: 6000
                        });
                    }
                    return;
                }
                const { isValid } = await this.$api.get(`org/validateSubdomain`, { subdomain: this.value, orgId: this.orgId });
                if (this.isInitial) {
                    if (!isValid) this.$emit('input', '');
                    this.isInitial = false;
                    return;
                }
                if (isValid) {
                    this.$emit('status-change', true);
                    return;
                }
                this.$store.dispatch('notification/set', {
                    type: 'info',
                    message: `Sorry, this site name is already taken. Please enter a new one.`,
                    timeout: 6000
                });
            },  600),
        },
    };
</script>

<style lang="scss" scoped>
</style>